export default function BottomSteps() {
  return (
    <section className="bottom-steps" data-testid="bottom-steps-section">
      <div className="bottom-steps-grid">
        <div className="step-card" data-testid="bottom-step-card-1">
          <div className="step-number">01 <span className="chevrons">&raquo;</span></div>
          <h3>Find Your Agreements</h3>
          <p>We can find your agreements and manage your claim in a few easy steps.</p>
          <a href="https://sa.yoursolicitor.co.uk/claim" data-ratifi-forward>Find My Agreements</a>
        </div>
        <div className="step-card" data-testid="bottom-step-card-2">
          <div className="step-number">02 <span className="chevrons">&raquo;</span></div>
          <h3>Check Your Eligibility</h3>
          <p>Our dedicated legal team will carefully prepare and submit your finance claim, managing everything from start to finish.</p>
        </div>
      </div>
    </section>
  );
}
